import { HORSE_AVATAR_BG } from 'assets/images'
import styled from 'styled-components'

const HorseImageContainer = styled.div`
  display: flex;
  justify-content: center;

  .background {
    background-image: url(${HORSE_AVATAR_BG});
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    background-size: contain;
    width: 300px;
    ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
      background-size: cover;
    }

    .avatar {
      width: 300px;
      aspect-ratio: 300 / 300;
      object-fit: contain;
      object-position: center;

      ${({ theme }) => theme.media.lessThan(theme.size.sm)} {
        width: 100%;
      }
    }

    .item {
      width: 300px;
      height: 300px;
      position: absolute;
      top: 0;
      left: 0;

      &.head {
        z-index: 3;
        width: 150px;
        height: 150px;
      }

      &.body {
        z-index: 2;
        height: 300px;
        top: 50%;
        transform: translateY(-50%);
      }

      &.bronze-body {
        left: 4px;
        height: 260px !important;
        transform: translateY(-50%) rotate(1deg);
      }

      &.foot {
        z-index: 4;
        width: 300px;
        height: auto;
        left: 0%;
        bottom: 0%;
        top: unset;
      }

      &.skin {
        z-index: 1;
      }

      &.shoes{
        width: 300px;
        height: auto;
        left: 0%;
        bottom: 0%;
        top: unset;
        z-index: 3;
      }
      &.glass{
        height: auto;
        width: 150px;
        top: 0%;
        left: 0%;
        z-index: 3;
      }
    }
  }
`

export default HorseImageContainer
